import { TournamentType } from "@nestcoinco/hyper-api-gateway-api-client";
import { ConnectAccountsEvents, PaymentEventTypes } from "./events-types";
import { SOCIAL, VIDEO, WEBPAGE } from "./links";
import {
  ROOT,
  ONBOARDING,
  GAMES,
  WALLET,
  SIGN_UP,
  LOG_IN,
  APP_INTENT_VALUES as APP,
} from "./routes";
export * from "./page-info";
export * from "./tracking-events";

export const HYPER_COIN_TO_NAIRA_RATE = 5; // 1 hyper coin = 5 naira
export const HYPER_COIN_TO_DOLLAR_RATE = 1 / 100; // 1 dollar = 100 hypercoin

export const EventTypes = {
  PAYMENTS: PaymentEventTypes,
  CONNECT_ACCOUNTS: ConnectAccountsEvents,
};

export const ROUTES = { ROOT, ONBOARDING, GAMES, WALLET, SIGN_UP, LOG_IN, APP };
export const LINKS = { WEBPAGE, VIDEO, SOCIAL };
export const LEGACY_FLOW_SUFFIX = "2";
export const MVM_EMAIL = "info@mvm.gg";
export const SPECIAL_OFFER_MARKER = "specialOffer";
export const BONUS_GEM_MARKER = "bonusGem";
export const BONUS_HPR_MARKER = "bonusHpr";
export const BONUS_PERCENT_MARKER = "bonusPercent";
export const ACH_FEE_MARKER = "ACH";
export const APPLE_PAY_FEE_MARKER = "APPLE_PAY";
export const CARD_FEE_MARKER = "CARD";
export const GOOGLE_PAY_FEE_MARKER = "GOOGLE_PAY";
export const PAYPAL_FEE_MARKER = "PAYPAL";
export const LEGAL_AGE = 18;

export const TTL = {
  SECONDS: (n: number) => n * 1000,
  MINUTES: (n: number) => n * 60 * 1000,
  HOURS: (n: number) => n * 60 * 60 * 1000,
  DAYS: (n: number) => n * 24 * 60 * 60 * 1000,
} as const;

export const LogLevel: {
  [key: string]: number;
} = {
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
  trace: 5,
} as const;

export enum AuthFlow {
  LOGIN = "login",
  SIGNUP = "signup",
}

export enum GameOutcome {
  WIN = "win",
  LOSS = "loss",
  DRAW = "draw",
  AWAITING_OPPONENT = "awaiting-opponent",
  AWAITING_SCORE = "awaiting-score",
  AWAITING_OPPONENT_SCORE = "awaiting-opponent-score",
  OPPONENT_CANCELLED = "opponent-cancelled",
  CANCELLED = "cancelled",
  WAITING_TO_BE_MATCHED = "waiting-for-match",
}

export enum GameFlowState {
  STARTING_GAME = "starting-game",
  VIEWING_RESULTS = "viewing-results",
  VIEWING_RESULTS_FOR_FAILED_GAME = "viewing-results-for-failed-game",
}

export enum GameType {
  BATTLE = "battle",
  PRACTICE = "practice",
  CHALLENGE = "challenge",
  TOURNAMENT = "tournament",
  SOLO = "solo",
}

export enum GameMode {
  SOLO = "solo",
  PVP = "1v1",
}

export enum HttpStatusCodes {
  FORBIDDEN = 403,
}

export enum OnboardingSteps {
  SET_EARNINGS_GOALS = "set-earnings-goals",
  SETTING_EARNINGS_GOALS = "setting-earnings-goals",
  SIGN_UP = "sign-up",
  LOG_IN_SUCCESSFUL = "log-in-successful",
  SIGN_UP_SUCCESSFUL = "sign-up-successful",
  USE_REFERRAL_CODE = "use-referral-code",
  CLAIM_USERNAME = "claim-username",
  VIEW_WELCOME = "view-welcome",
  EXPLORE_GAMES = "explore-games",
  PAYWALL = "paywall",
  FIND_FRIENDS = "find-friends",
  JOIN_COMMUNITY = "join-community",
  GET_APP = "get-app",
  INSTALL_TEST_FLIGHT = "install-testflight",
  TURN_ON_NOTIFICATIONS = "turn-on-notifications",
  VIEW_INSURANCE_BONUS = "view-insurance-bonus",
  VIEW_WELCOME_BACK = "view-welcome-back",
}

export const MOBILE_APP_TO_WEB_APP_ROUTE_MAP: Record<string, string> = {
  [ROUTES.ROOT.DASHBOARD]: APP.HOME,
  [ROUTES.WALLET.ROOT]: APP.WALLETS,
  [ROUTES.WALLET.TOPUP_PENDING]: APP.TOPUP_PENDING,
  [ROUTES.WALLET.TOPUP_SUCCESSFUL_FIRST]: APP.TOPUP_SUCCESSFUL,
  [ROUTES.WALLET.TOPUP_SUCCESSFUL_RETURN]: APP.TOPUP_SUCCESSFUL,
  [ROUTES.WALLET.TOPUP_FAILED]: APP.TOPUP_FAILED,
};

export const TOURNAMENT_TO_GAME_TYPE_MAP: Record<
  TournamentType,
  Exclude<GameType, GameType.PRACTICE | GameType.SOLO>
> = {
  [TournamentType.DUEL]: GameType.BATTLE,
  [TournamentType.CHALLENGE]: GameType.CHALLENGE,
  [TournamentType.MULTI]: GameType.TOURNAMENT,
  [TournamentType.FREE_FOR_ALL]: GameType.TOURNAMENT,
};

export enum TopupOrigins {
  WEB = "web",
  MOBILE = "mobile",
}

const LANGUAGE_KEYS = {
  EN: "en",
};
export const SUPPORTED_LANGUAGES: Record<string, { nativeName: string }> = {
  [LANGUAGE_KEYS.EN]: { nativeName: "English" },
};

export enum GamePlayEvents {
  GAME_START = "GameStart",
  GAME_END = "GameEnd",
  GAME_FAILED = "GameFailed",
  GAME_PAUSE = "GamePause",
  GAME_RESUME = "GameResume",
  SCORE_RECEIVED = "ScoreReceived",
  PRACTICE_GAME_END = "PracticeGameEnd",
  SDK_CONNECTION_FAILED = "sdk_ConnectionFailed",
  SDK_WRONG_PLATFORM = "sdk_WrongPlatform",
  SDK_WRONG_ORIENTATION = "sdk_WrongOrientation",
  SDK_SESSION_TIMEOUT = "sdk_SessionTimedOut",
  SDK_GAME_END_NO_INTERNET = "sdk_GameEndNoInternet",
}

export enum AppDownloadPlatforms {
  ANDROID = "Android",
  TRANSSION = "Transsion",
  AMAZON = "Amazon",
  APPLE = "Apple",
}
